<script>
import {useSearchStore} from "@js/store/SearchStore.js";
import {ref} from "vue";
import IconX from "@js/components/Icons/IconX.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import {router} from "@inertiajs/vue3";
import ImageSearchUploadSection from "@js/components/Sections/ImageSearch/ImageSearchUploadSection.vue";

export default {
    name: "ImageSearchPopup",
    components: {ImageSearchUploadSection, OnlyMobile, IconX},
    mounted() {
        router.on("before", (event) => {
            this.searchStore.hideImageSearch();
        })
    },
    setup() {
        const searchStore = useSearchStore();
        const modalRef = ref(null);

        // Закрытие модалки по клику вне контейнера
        const handleBackgroundClick = (event) => {
            if (!modalRef.value.contains(event.target)) {
                searchStore.hideImageSearch();
            }
        };

        // Обработка свайпа вниз
        const touchStartY = ref(0);
        const touchDeltaY = ref(0);
        const onTouchStart = (e) => {
            touchStartY.value = e.touches[0].clientY;
        };
        const onTouchMove = (e) => {
            touchDeltaY.value = e.touches[0].clientY - touchStartY.value;
            if (touchDeltaY.value > 0 && modalRef.value) {
                modalRef.value.style.transform = `translateY(${touchDeltaY.value}px)`;
            }
        };
        const onTouchEnd = () => {
            if (touchDeltaY.value > 100) {
                searchStore.hideImageSearch();
            } else if (modalRef.value) {
                // Вернуть в исходное положение
                modalRef.value.style.transition = "transform 0.3s";
                modalRef.value.style.transform = "translateY(0)";
                setTimeout(() => {
                    if (modalRef.value) {
                        modalRef.value.style.transition = "";
                    }
                }, 300);
            }
            touchDeltaY.value = 0;
        };

        return {
            searchStore,
            modalRef,
            handleBackgroundClick,
            onTouchStart,
            onTouchMove,
            onTouchEnd,
        };
    },
};
</script>

<template>
    <div v-if="searchStore.imageSearch.isOpen"
         class="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black bg-opacity-70 transition-opacity"
         @click="handleBackgroundClick">
        <div ref="modalRef"
             @touchstart.passive="onTouchStart"
             @touchmove.passive="onTouchMove"
             @touchend="onTouchEnd"
             :class="{ 'top-i-0': searchStore.imageSearch.isOpen && searchStore.imageSearch.animation_in_progress }"
             class="relative top-[100%] bg rounded-tr-2xl rounded-tl-2xl sm:rounded-2xl shadow-lg max-h-[450px] sm:max-w-[800px] sm:max-h-[450px] w-full h-full transition-all duration-500 ">
            <OnlyMobile :maxSize="1024">
                <button @click.prevent="searchStore.hideImageSearch"
                        class="absolute top-2 right-2 md:-top-10 md:-right-10 text-gray-400 md:hover:text-white focus:outline-none">
                    <IconX
                        class="h-7 w-7 md:h-10 md:w-10 stroke-[#000] md:stroke-[#fff] active:stroke-baseColor md:hover:sm:stroke-baseColor transition"/>
                </button>
                <div class="absolute top-3 right-0 left-0 m-auto flex justify-center">
                    <div class="h-[5px] w-[50px] bg-gray-400 rounded-full"></div>
                </div>
            </OnlyMobile>
            <div class="w-full h-full p-5">
                <ImageSearchUploadSection/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.bg {
    background-color: white;
}

@media (min-width: 1024px) {
    .bg {
        background: linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)),
        url("@img/search/bg.webp") no-repeat bottom;
        background-size: cover !important;
    }
}
</style>
